import {BASE_URL} from "app/config/env";

export const publicRoutes = {
  'public.privacyPolicy': `${BASE_URL}/privacy-policy`,
  'public.rules':         `${BASE_URL}/regulations`,
  'public.euProject':     `${BASE_URL}/eu-project`,
  'public.contact':       `${BASE_URL}/contact`,
  'public.pricing':       `${BASE_URL}/pricing`,
  'public.faq':           `${BASE_URL}/faq`,
}
